function veda_fn_id_ec864a3c9a47408a80ffd8da432aae96() {
    
    try {
      const uniqueId = /* _____Start/Id_____ */"id_ec864a3c-9a47-408a-80ff-d8da432aae96"/* _____End/Id_____ */;
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]:not(addons, megamenu)`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        /* _____Start/Content_____ */
        const { interpolate } = veda.utils;
const barEl = container.querySelector(".bar-js");
const OFFSET = 200;

function handler() {
  if (window.scrollY > OFFSET) {
    container.style.opacity = "1";
    container.style.visibility = "visible";
    container.style.transform = "translateY(0)";
  } else {
    container.style.removeProperty("opacity");
    container.style.removeProperty("visibility");
    container.style.removeProperty("transform");
  }
  const val = interpolate({
    value: window.scrollY,
    inputRange: [OFFSET, document.body.offsetHeight - window.innerHeight],
    outputRange: [125, 0],
  });
  barEl.style.strokeDashoffset = val;

  const tabNavigatorEl = document.querySelector(".veda-tab-navigator");
  if (!!tabNavigatorEl) {
    container.style.marginBottom = `${tabNavigatorEl.offsetHeight}px`;
  }
}

function handleScrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

handler();
window.addEventListener("scroll", handler);
container.addEventListener("click", handleScrollToTop);

onCleanup(() => {
  window.removeEventListener("scroll", handler);
  container.removeEventListener("click", handleScrollToTop);
});


        /* _____End/Content_____ */
      });
    } catch (error) {
      console.log(error);
    }
  };
veda_fn_id_ec864a3c9a47408a80ffd8da432aae96();
